module.exports = __webpack_public_path__ + "8b6f2ec29629876f9c00839932ded057.svg";